import { render, staticRenderFns } from "./VerifyUser.vue?vue&type=template&id=5f2ee012&scoped=true"
import script from "./VerifyUser.vue?vue&type=script&lang=js"
export * from "./VerifyUser.vue?vue&type=script&lang=js"
import style0 from "./VerifyUser.vue?vue&type=style&index=0&id=5f2ee012&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2ee012",
  null
  
)

export default component.exports